import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

export const editPartSetupSchema = () =>
  yup.object({
    category: yup
      .object()
      .label(t('labelCategories'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelCategories'))),
    description: yup.string().label(t('labelDescription')).nullable(),
    orderingNumber: yup.string().label(t('labelOrderingNumber')).nullable(),
    engineeringNumber: yup.string().label(t('labelEngineeringNumber')).nullable(),
  });
